// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3ZJCe","emails":"CreateEditClinics_emails__2yYwA","emailTagLabel":"CreateEditClinics_emailTagLabel__2VZqP"};